import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <section className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-[#4f9067]">404</h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mt-4">
          Страница не найдена
        </h2>
        <p className="text-gray-600 mt-2 mb-8">
          К сожалению, запрашиваемая страница не существует или была удалена.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="bg-[#4f9067] text-white px-6 py-3 rounded-lg hover:bg-[#3f7252] transition font-medium"
          >
            На главную
          </Link>
          <button
            onClick={() => window.history.back()}
            className="border-2 border-[#4f9067] text-[#4f9067] px-6 py-3 rounded-lg hover:bg-[#4f9067] hover:text-white transition font-medium"
          >
            Назад
          </button>
        </div>
      </div>
    </section>
  );
}
